<template>
  <section class="item">
    <div class="flex setting-box" >
      <span>Custom</span>
      <span>By {{form.way==1?'Enable':'Disable'}} Product</span>
    </div>
    <div
      class="table_group mg-t-20">
      <div class="fileTable table_item">
        <!--        <div class="flex-center mg-b-20">-->
        <!--          <div>-->
        <!--            <span-->
        <!--              class="blue pointer"-->
        <!--              @click="selectAll">Select All</span>-->
        <!--            <span-->
        <!--              class="blue pointer mg-l-20"-->
        <!--              @click="clearAll">Clear All</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <p
          v-if="isEdit"
          class="fs-14 fw-400 mg-b-20">Select the items you <span
            v-if="form.way==2"
            class="color-red red fs-14">NOT</span> need</p>
        <el-table
          ref="table"
          :data="tableList"
          :header-row-class-name="'tableHeader'"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            v-if="isEdit"
            type="selection"
            width="55"></el-table-column>

          <el-table-column
            label="Company"
          >
            <template #default="{row}">
              <span class="flex-align-center">
                <template v-if="!isEdit">
                  <img
                    v-if="form.way==2"
                    class="icon-content"
                    src="@/assets/images/icon/list-cross.svg">
                  <img
                    v-else
                    class="icon-content"
                    src="@/assets/images/icon/list-tick.svg">
                </template>
                <span>{{row.company_language}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="class_language"
            label="Class"
          ></el-table-column>

          <el-table-column
            prop="plan_name"
            label="Plan"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'product-setting-display',
  props:{
    form:{
      type:Object,
      default:()=>{}
    },
    tableData:{
      type:Array,
      default:()=>[]
    },
    oldTableData:{
      type:Array,
      default:()=>[]
    },
    isEdit:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      selectData:[],
    }
  },
  computed:{
    tableList(){
      let arr =[]
      this.tableData.forEach((item)=>{
        arr.push({...item,id:`${item.company_id}${item.class_id}${item.plan_id}`})
      })
      return arr
    }
  },
  watch:{
    oldTableData:{
      immediate:true,
      handler(val){
        if(val){
          this.$nextTick(()=>{
            val.forEach(item => {
              item.id = `${item.company_id}${item.class_id}${item.plan_id}`
              this.tableList.forEach(table => {
                if (item.id == table.id)
                  this.$nextTick(() => {
                    this.$refs.table.toggleRowSelection(table, true)
                  })
                this.selectData.push(item.id)
              })
            })
          })
        }
      }
    }
  },
  methods:{
    handleSelectionChange(val){
      this.selectData =val.reduce((result,item)=>{
        result.push(item.id)
        return result
      },[])
    },
    getProductList(){
      let arr = []
      this.selectData.forEach(item=>{
        this.tableList.forEach((table) => {
          if(table.id ==item)
            arr.push(table)
        })
      })
      return arr
    },
    selectAll() {
      this.selectData = [...this.tableData]
    },
    clearAll(){
      this.selectData = []
    }
  }
}
</script>


<style scoped lang="scss">
.item{
  margin-top: 24px;
  .header{
    display: flex;
    justify-content: space-between;
    .header_title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .setting-box{
    span{
      border: 1px solid rgba(106, 115, 125, 1);
      padding:1px 8px;
      border-radius: 20px;
      margin-right: 16px;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .icon-content{
    margin-right: 8px;
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        //display: flex;
        padding: 10px 15px 10px 0px!important;
        vertical-align: top;
        margin-right: 15px;
        //height: 40px;
        .cell{
          //min-height: 40px;
          line-height: 20px;
          position: relative;
          height: inherit;
          //margin-left: 10px;
          //margin-right: 10px;
          //padding: 0;
          color: #24292E;
          //padding: 5px 10px;
          //position: absolute;
          //top: 10px;
          .liter-text{
            color: #6A737D;
            font-size: 12px;
            &.tag-border{
              border: 1px solid #dddfe7;
              border-radius: 4px;
              text-align: center;
              line-height: 18px;
            }
          }
        }
      }
    }
    .table-pointer{
      cursor: pointer;
    }
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        //padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }


  }

}
</style>
